import { Plus as AddIcon } from "lucide-react";
import { Helmet } from "react-helmet";

import { CustomersType } from "api/customers/types";
import PageLayout from "components/layouts/PageLayout";
import { hasPermissions } from "components/stores/UserStore";
import UltimateButton from "components/UltimateButton";
import { useModal } from "utils/hooks/useModal";

import CustomersTable from "./CustomersTable";
import NewCustomerModal from "./CustomersTable/components/NewCustomerModal";
import { useCustomersFilter } from "./CustomersTable/useCustomersFilter";

const CustomersPage = () => {
  const { filters, searchField } = useCustomersFilter();
  const { isOpen, handleClose, handleOpen } = useModal<CustomersType>();

  return (
    <>
      <Helmet title="Lendzee | All Customers" />
      <PageLayout
        title="Customers List"
        subtitle="View and manage customer records and contact details."
        search={{
          value: searchField.value,
          onChange: searchField.onChange,
          placeholder: "Search by name, email or address",
        }}
        actions={
          hasPermissions("write:customers") ? (
            <UltimateButton
              text="Add Customer"
              Icon={
                AddIcon as React.ComponentType<{
                  size?: number;
                  className?: string;
                  style?: React.CSSProperties;
                }>
              }
              sx={{
                py: 1,
              }}
              onClick={() => handleOpen()}
            />
          ) : undefined
        }
      >
        <CustomersTable filters={filters} />
      </PageLayout>
      {hasPermissions("write:customers") && (
        <NewCustomerModal isOpen={isOpen} handleClose={handleClose} />
      )}
    </>
  );
};

export default CustomersPage;
